import _ from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
//import Paper from '@material-ui/core/Paper';
//import Grid from '@material-ui/core/Grid';
//
//
// NOT DONE.
// = The plan is the data will be saved on the invoice (locked in) and
// = then passed here so it can be used to print out hte graphical formula
//
//

import BulkInvoiceContainer from '../../containers/accounting/BulkInvoice';
import pfLogo from '../../images/pearsonFuelsLogoV2.png';
import { calcBulkFormula } from '../../libs/formulas';
import WarningIcon from '@material-ui/icons/Warning';

const styles = () => {
	const p = (v) => {
		return `${v * 100}%`;
	};
	const pBlue = '#0790CB';
	const lineColor = '#D9D9D9';
	const rowLineColor = '#f1f1f1';

	return {
		root: {
			position: 'absolute',
			backgroundColor: 'white',
			height: '100%',
			width: '100%',
		},
		container: {
			position: 'relative',
			height: '100%',
			width: '100%',
			padding: `${p(0.065)} ${p(0.075)}`,
			boxSizing: 'border-box',
			fontFamily: 'Roboto',
			color: '#666',
			fontSize: '1.8vw',
		},
		containerWrapper: {
			position: 'relative',
			height: '100%',
			width: '100%',
			//border : '1px solid red',
		},

		logo: {
			marginTop: p(0.02),
			width: p(0.52),
			//height : p(0.),
		},

		formulaName: {
			fontSize: '130%',
			fontWeight: 900,
		},
		formulaUpdated: {
			fontWeight: 200,
			color: '#999',
		},
		formulaTitle: {
			textTransform: 'uppercase',
			color: '#999',
			paddingBottom: 10,
		},
		formulaRow: {
			display: 'flex',
			flexDirection: 'row',
			paddingBottom: 2,
		},
		formulaTotal: {
			borderTop: '2px solid #ccc',
			paddingTop: '5px',
			marginTop: '5px',
			display: 'flex',
			flexDirection: 'row',
			fontWeight: '800',
			paddingBottom: '15px',
		},
		formulaSubtotal: {
			marginLeft: '10%',
			marginRight: '10%',
			borderTop: '1px solid #ddd',
			paddingTop: '5px',
			marginTop: '5px',
			paddingBottom: '15px',
			display: 'flex',
			flexDirection: 'row',
			fontWeight: '800',
		},
		bigInvoiceContainer: {
			marginTop: '9%',
			borderTop: `1px solid ${lineColor}`,
			borderBottom: `1px solid ${lineColor}`,
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			padding: '1% 0%',
			lineHeight: '1.4',
		},
		bigInvoice: {
			fontSize: '6.2vw',
			fontWeight: 100,
			color: pBlue,
			flexBasis: '45%',
		},
		billingInfo: {
			textAlign: 'left',
			marginRight: '3%',
			flexBasis: '55%',
		},
		label: {
			fontWeight: 600,
			color: '#111',
			letterSpacing: '.1em',
		},
		itemSection: {
			marginTop: '12%',
			width: '60%',
			marginLeft: '25%',
			fontSize: '100%',
		},
		labelLine: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderBottom: `1px solid ${lineColor}`,
			paddingBottom: '.4vw',
			fontWeight: 600,
			color: '#111',
			letterSpacing: '.1em',
			textTransform: 'uppercase',
		},
		colDescription: {
			flexBasis: '80%',
			textAlign: 'left',
		},
		colQuantity: {
			flexBasis: '20%',
			textAlign: 'right',
		},
		colUnitCost: {
			flexBasis: '20%',
			textAlign: 'right',
		},
		colSubTotal: {
			flexBasis: '20%',
			textAlign: 'right',
		},
		itemRow: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderTop: `1px solid ${rowLineColor}`,
			paddingTop: '.9vw',
			paddingBottom: '.9vw',
			//letterSpacing : '.1em',

			paddingRight: '1vw',
			paddingLeft: '1vw',
		},
		rowSubTotal: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderTop: `1px solid ${lineColor}`,
			paddingTop: '.9vw',
			paddingBottom: '.9vw',
			//letterSpacing : '.1em',
			fontWeight: 900,
			marginBottom: '2vw',

			paddingRight: '1vw',
			paddingLeft: '1vw',
		},
		rowTotal: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderTop: `1px solid ${pBlue}`,
			paddingTop: '1.5vw',
			paddingBottom: '1.5vw',
			//letterSpacing : '.1em',
			fontWeight: 900,
			marginBottom: '2vw',
			fontSize: '110%',
			backgroundColor: '#f8f8f8',
			paddingRight: '1vw',
			paddingLeft: '1vw',
		},
		miniTotalSection: {
			display: 'flex',
			flexDirection: 'row',
			textAlign: 'right',
			justifyContent: 'flex-end',
			marginTop: '3%',
		},
		poInfo: {
			marginTop: '6%',
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
		},
		poGroup: {
			flexGrow: 1,
			marginRight: '6%',
			'&:last-child': {
				marginRight: '0%',
			},
		},
		poLabel: {
			fontWeight: 600,
			color: '#111',
			letterSpacing: '.1em',
			borderBottom: `1px solid ${lineColor}`,
			paddingBottom: '.4vw',
			textTransform: 'uppercase',
			marginBottom: '.5vw',
		},

		formulaLabel: {
			color: '#333',
			flexBasis: '50%',
			textAlign: 'right',
			paddingRight: '8px',
		},
		formulaValue: {
			color: '#666',
			flexBasis: '50%',
			textAlign: 'left',
		},

		bottomSection: {
			position: 'absolute',
			bottom: '0%',
			width: '100%',
			marginBottom: '2%',
		},

		termAndTotal: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			marginTop: '.8%',
		},
		termParagraph: {
			fontSize: '92%',
			color: '#999999',
			textAlign: 'left',
			fontWeight: 200,
			flexBasis: '100%',
		},
	};
};

class BulkFormula extends Component {
	constructor(props) {
		super(props);
		const bulkInvoiceId = _.get(this.props, ['match', 'params', 'bulkInvoiceId']);
		const securityHash = _.get(this.props, ['match', 'params', 'securityHash']);

		this.state = {
			bulkInvoiceId: bulkInvoiceId ? parseInt(bulkInvoiceId, 10) : undefined,
			securityHash,
			errors: [],
		};
	}

	componentDidMount() {
		//- Only used for updates
		const { publicGetBulkInvoice, bulkInvoice } = this.props;
		const { bulkInvoiceId, securityHash } = this.state;
		if (bulkInvoice) {
			return;
		}

		publicGetBulkInvoice({
			params: {
				bulkInvoiceId,
				securityHash,
				includeQuickbooksCustomers: true,
				includeQuickbooksTerms: true,
			},
		});
	}

	getDataDumpData = () => {
		const { bulkInvoice, bulkQuotedPriceMap, bulkFormulaMap, dataDumpMap } = this.props;

		if (!bulkInvoice) {
			return { error: 'Missing bulk invoice. Contact support.' };
		}

		const { bulkQuotedPriceId } = bulkInvoice;
		if (!bulkQuotedPriceId) {
			return { error: 'Missing quoted price. Contact support.' };
		}

		const bulkQuotedPrice = bulkQuotedPriceMap[bulkQuotedPriceId];

		if (!bulkQuotedPrice) {
			return { error: 'Could not find bulk quoted price in map. Contact support.' };
		}

		const { dataDumpId, bulkFormulaId } = bulkQuotedPrice;
		if (!dataDumpId) {
			return { error: 'Quoted price missing data dump. This estimate cant be used. Sorry.' };
		}

		const dataDump = dataDumpMap[dataDumpId];
		if (!dataDump) {
			return { error: 'Could not get data from dataDumpMap' };
		}

		const bulkFormula = bulkFormulaMap[bulkFormulaId];
		if (!bulkFormula) {
			return { error: `Bulk formula not found ${bulkFormulaId}` };
		}

		return { data: dataDump.data, bulkFormula };
	};

	render() {
		const { classes, bulkInvoice } = this.props;

		if (!bulkInvoice) {
			return <div>Fetching bulk invoice...</div>;
		}

		const { error, data, bulkFormula } = this.getDataDumpData();

		if (error) {
			return (
				<div>
					<div>Encountered an error when retrieving the data for formula</div>
					<div>{error}</div>);
				</div>
			);
		}

		const { bulkFormulaKey, display } = bulkFormula;
		if (bulkFormulaKey !== 'seaportRefining') {
			return (
				<div>
					<div style={{ padding: 20 }}>
						<strong>ERROR</strong> : Printable formulas are only implemented for Seaport Refining.
					</div>
				</div>
			);
		}

		const r = calcBulkFormula({ bulkFormulaKey, data });

		let formulaRows = _.isArray(r.formulaRows) ? r.formulaRows : [];

		return (
			<div className={classes.root}>
				<div className={classes.container}>
					<div className={classes.containerWrapper}>
						<img alt="Logo" className={classes.logo} src={pfLogo} />

						<div className={classes.bigInvoiceContainer}>
							<div className={classes.bigInvoice}>FORMULA</div>
							<div className={classes.billingInfo}>
								<div className={classes.formulaName}>Bulk Pricing for {display}</div>
								<div className={classes.formulaUpdated}>Pricing agreement</div>
								<div className={classes.formulaUpdated}>Revision Date: 9/8/2014</div>
							</div>
						</div>

						<div className={classes.itemSection}>
							<div className={classes.labelLine}>
								<div className={classes.colDescription}>DESCRIPTION</div>
								<div className={classes.colQuantity}>VALUE</div>
							</div>

							{/*
					{formulaRows.map((lineItem, i) => {
						const { description, value, isTotal, isSubtotal} = lineItem;

						const className = (isSubtotal) ? 'rowSubTotal' : (isTotal) ? 'rowTotal' : 'itemRow';

						return (<div key={i} className={classes[className]}>
							<div className={classes.colDescription}>{description}</div>
							<div className={classes.colQuantity}>{value}</div>
						</div>);
					})}
					*/}

							{formulaRows.map((formulaRow, i) => {
								const { label, value, isSubtotal, isTotal, isTitle, notImplemented } = formulaRow;

								let className = 'itemRow';
								if (isSubtotal) {
									className = 'rowSubTotal';
								} else if (isTotal) {
									className = 'rowTotal';
								}

								let displayValue = value;
								if (_.isNumber(displayValue) && !_.isNaN(displayValue)) {
									displayValue = parseFloat(displayValue.toFixed(5)).toFixed(5);
								} else {
									displayValue = '???';
								}

								if (isTitle) {
									return null;
								} else if (notImplemented) {
									return (
										<div key={`fr${i}`} className={classes.formulaRow}>
											<WarningIcon className={classes.warning} /> {label}
										</div>
									);
								} else {
									return (
										<div key={`fr${i}`}>
											{isSubtotal && <div className={classes.formulaSubtotalLine} />}
											<div className={classes[className]}>
												<div className={classes.colDescription}>{label}</div>
												<div className={classes.colQuantity}>{displayValue}</div>
											</div>
										</div>
									);
								}
							})}
						</div>

						<div className={classes.bottomSection}>
							<div className={classes.labelLine}>
								<div>Terms &amp; Conditions</div>
							</div>
							<div className={classes.termAndTotal}>
								<div className={classes.termParagraph}>- Prices do not include any taxes.</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

BulkFormula.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func,

	//- Batch
	publicGetBulkInvoice: PropTypes.func,
	bulkInvoice: PropTypes.object,
	bulkQuotedPriceMap: PropTypes.object,
	bulkFormulaMap: PropTypes.object,
	dataDumpMap: PropTypes.object,
};

export default _.flow([withStyles(styles), BulkInvoiceContainer])(BulkFormula);
